interface SMSPreviewProps {
  businessName: string;
  messages: { text: string; type: 'outbound' | 'inbound' }[];
}

export default function SMSPreview({ businessName, messages }: SMSPreviewProps) {
  // If we just have raw text, split into messages
  const displayMessages = messages.length > 0 ? messages : [{ text: 'No SMS content to preview.', type: 'outbound' as const }];

  return (
    <div className="max-w-[320px] mx-auto">
      {/* iPhone frame */}
      <div className="bg-charcoal-800 rounded-[2.5rem] p-2 shadow-2xl">
        {/* Notch */}
        <div className="bg-charcoal-900 rounded-t-[2rem] pt-2">
          <div className="flex justify-center">
            <div className="w-20 h-5 bg-charcoal-800 rounded-b-2xl" />
          </div>
        </div>

        {/* Screen */}
        <div className="bg-gray-100 rounded-b-[2rem] overflow-hidden">
          {/* SMS header */}
          <div className="bg-gray-200/80 backdrop-blur px-4 py-2.5 flex items-center gap-3 border-b border-gray-300">
            <span className="text-blue-500 text-sm">‹</span>
            <div className="flex-1 text-center">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-copper-400 to-copper-600 mx-auto flex items-center justify-center text-white text-xs font-bold">
                {businessName.charAt(0)}
              </div>
              <p className="text-[10px] font-medium text-gray-700 mt-0.5 truncate">{businessName}</p>
            </div>
            <span className="text-blue-500 text-sm opacity-0">‹</span>
          </div>

          {/* Messages area */}
          <div className="p-3 space-y-2 min-h-[300px] max-h-[400px] overflow-auto bg-white">
            {/* Timestamp */}
            <p className="text-[10px] text-gray-400 text-center mb-3">Today 10:30 AM</p>

            {displayMessages.map((msg, i) => (
              <div key={i} className={`flex ${msg.type === 'outbound' ? 'justify-start' : 'justify-end'}`}>
                <div className={`
                  max-w-[85%] rounded-2xl px-3 py-2 text-[13px] leading-relaxed
                  ${msg.type === 'outbound'
                    ? 'bg-gray-200 text-gray-800 rounded-bl-md'
                    : 'bg-blue-500 text-white rounded-br-md'
                  }
                `}>
                  {msg.text}
                </div>
              </div>
            ))}
          </div>

          {/* Input bar */}
          <div className="bg-gray-100 px-3 py-2 flex items-center gap-2 border-t border-gray-200">
            <div className="w-7 h-7 rounded-full bg-gray-300 flex items-center justify-center text-gray-500 text-xs">+</div>
            <div className="flex-1 bg-white rounded-full px-3 py-1.5 text-xs text-gray-400 border border-gray-200">
              iMessage
            </div>
            <div className="w-7 h-7 rounded-full bg-blue-500 flex items-center justify-center text-white text-[10px]">↑</div>
          </div>

          {/* Home indicator */}
          <div className="flex justify-center py-2 bg-gray-100">
            <div className="w-28 h-1 bg-charcoal-300 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
